import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { storeDevtools } from 'wflow-main-app/src/environments/environment';
import { IdentitiesEffects } from './identity/identity.effects';
import { OrgIdentityReducer } from './identity/identity.reducer';
import { IntegrationEffects } from './integrations/integration.effects';
import { IntegrationReducer } from './integrations/integration.reducer';
import { OrganizationsEffects } from './organizations/organizations.effects';
import { organizationsReducer } from './organizations/organizations.reducer';
import { routerReducer } from './router/router.reducer';
import { RouterEffects } from './router/router.effects';
import { SettingsEffects } from './settings/settings.effects';
import { SettingsReducer } from './settings/settings.reducer';
import { UserEffects } from './user/user.effects';
import { UserReducer } from './user/user.reducer';
import { globalReducer } from './global/global.reducer';
import { GlobalEffects } from './global/global.effects';

/**
 * Store structure
 * Register all reducers here
 */
const STORE = {
  router: routerReducer,
  user: UserReducer,
  integration: IntegrationReducer,
  organizations: organizationsReducer,
  settings: SettingsReducer,
  identities: OrgIdentityReducer,
  global: globalReducer,
};

// Register all effects here
const STORE_EFFECTS = [
  RouterEffects,
  UserEffects,
  IntegrationEffects,
  OrganizationsEffects,
  SettingsEffects,
  IdentitiesEffects,
  GlobalEffects,
];

const STORE_MODULES: any[] = [
  StoreModule.forRoot(STORE, {
    runtimeChecks: {
      strictActionImmutability: false,
    },
  }),
  EffectsModule.forRoot(STORE_EFFECTS),
  ...storeDevtools,
];

@NgModule({
  imports: STORE_MODULES,
  exports: STORE_MODULES,
})
export class GlobalStoreModule {}
